<template>
    <button
        type="button"
        class="cookies-link"
        tabindex="-1"
        @click="openCookieSettings"
    >
        {{ $t(`Disclaimer.oneTrustCookie`) }}
    </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CookiesLink',
    setup() {
        const openCookieSettings = () => {
            const popupOpenButton = document.querySelector(
                '.ot-floating-button__open'
            );

            if (!popupOpenButton) {
                return;
            }

            const clickEvent = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
            });

            popupOpenButton.dispatchEvent(clickEvent);
        };

        return {
            openCookieSettings,
        };
    },
});
</script>
